import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetCampaigns() {
  const URL = endpoints.campaign.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      campaigns: response?.campaigns || [],
      campaignsLoading: isLoading,
      campaignsError: error,
      campaignsValidating: isValidating,
      campaignsEmpty: !isLoading && !response?.campaigns?.length,
    }),
    [response?.campaigns, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function createCampaign(apiData) {
  const URL = endpoints.campaign.list;

  try {
    const { data } = await axios.post(endpoints.campaign.create, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating campaign:', error);
    throw error;
  }
}

export async function updateCampaign(apiData) {
  const URL = endpoints.campaign.list;
  try {
    const { data } = await axios.put(endpoints.campaign.update, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating campaign:', error);
    throw error;
  }
}
export async function changeStatus(apiData) {
  const URL = endpoints.campaign.list;
  try {
    const { data } = await axios.put(endpoints.campaign.changeStatus, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating campaign:', error);
    throw error;
  }
}

export async function deleteCampaign(campaignId) {
  const URL = endpoints.campaign.list;

  try {
    const { data } = await axios.delete(`${endpoints.campaign.delete}/${campaignId}`);
    if (data.code === 200) {
      mutate(
        URL,
        (currentData) => {
          const currentCampaigns = currentData?.data?.campaigns || [];
          const updatedCampaigns = currentCampaigns.filter((campaign) => campaign._id !== campaignId);
          return {
            ...currentData,
            data: {
              campaigns: updatedCampaigns
            }
          };
        },
        false
      );
    }

    return data;
  } catch (error) {
    console.error('Error deleting campaign:', error);
    throw error;
  }
}

export function useGetCampaignReport() {
  const URL = endpoints.campaign.report;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      campaigns: response || [],
      campaignsLoading: isLoading,
      campaignsError: error,
      campaignsValidating: isValidating,
      campaignsEmpty: !isLoading && !response?.campaigns?.length,
    }),
    [response?.campaigns, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function campaignReload() {
  const URL = endpoints.campaign.list;
  try {
    await mutate(URL);
  } catch (error) {
    console.error('Error fetching campaign:', error);
    throw error;
  }
}